import axios from '../axiosApi';
import {
    FETCH_THOT_AUTOCLAVESMONITOR,
    FETCH_THOT_I4MONITOR, RECEIVE_THOT_AUTOCLAVESMONITOR, RECEIVE_THOT_I4MONITOR
} from "./actionTypes";
import {fetchRecebidosFinalizados, receiveRecebidosFinalizados} from "./orderActions";
import jwt from "jwt-decode";


export const fetchI4Monitor =  () => ({
    type: FETCH_THOT_I4MONITOR
});

export const receiveI4Monitor = payload => ({
    type: RECEIVE_THOT_I4MONITOR,
    payload: payload
})

export const fetchAutoclavesMonitor =  () => ({
    type: FETCH_THOT_AUTOCLAVESMONITOR
});

export const receiveAutoclavesMonitor = payload => ({
    type: RECEIVE_THOT_AUTOCLAVESMONITOR,
    payload: payload
})



export const getThotI4Monitor = () => {
    return async (dispatch, getState) => {
        dispatch(fetchI4Monitor());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            console.log("getThotI4Monitor");
            const { periodMin, periodMax } = getState().filter;
            let url = `/thot/i4monitor?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log(url);
            const response = await axios.get(url)
            console.log("response getThotI4Monitor", response);
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
        }
        finally {
            dispatch(receiveI4Monitor(payload));
        }
    }
}


export const getThotAutoclavesMonitor = () => {
    return async (dispatch, getState) => {
        dispatch(fetchAutoclavesMonitor())
        let payload = {
            tntId: 0,
            ix: 0,
            data: []
        }
        let tntId = 0;
        let ix = 0;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;
            const stt = jwt(getState().auth.jwt).thotTenants;
            const arrayTnt = stt.split(',');
            if (arrayTnt.length >0) {
                tntId = 0;

                 ix = getState().thot.lastAutoclaveTntIx;
                console.log("arrayTnt", arrayTnt);
                console.log("lastTntIx atual", ix)

                if (ix < (arrayTnt.length-1)) {
                    ix++;
                } else {
                    ix = 0;
                }
                tntId = arrayTnt[ix];

                payload = {
                    ...payload,
                    ix : ix,
                    tntId: tntId
                }


                console.log("getThotAutoclavesMonitor", tntId);

                if (tntId === 0) {
                    dispatch(receiveAutoclavesMonitor(payload));
                    return;
                }
                const {periodMin, periodMax} = getState().filter;
                let url = `/thot/autoclaves-monitor?tntId=${tntId}`;
                console.log(url);
                const response = await axios.get(url)
                console.log("response getThotI4Monitor", response);
                let r = {
                    ix: ix,
                    tntId: tntId,
                    tDescricao: response.data? response.data[0].tDescricao : '',
                    estabelecimentoTipoId: response.data? response.data[0].estabelecimentoTipoId : 0,
                    data: response.data
                }

                payload = r;
            }
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e, ix: ix, tntId: tntId };
        }
        finally {
            dispatch(receiveAutoclavesMonitor(payload));
        }
    }
}

export const getThotAutoclavesMonitorTenant = ( tId) => {
    return async (dispatch, getState) => {
        dispatch(fetchAutoclavesMonitor())
        let payload = {
            tntId: 0,
            ix: 0,
            data: []
        }
        let tntId = 0;
        let ix = 0;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;
            const stt = jwt(getState().auth.jwt).thotTenants;
            const arrayTnt = stt.split(',');
            if (arrayTnt.length >0) {
                tntId = 0;

                ix = getState().thot.lastAutoclaveTntIx;
                console.log("arrayTnt", arrayTnt);
                console.log("lastTntIx atual", ix)

                if (ix < (arrayTnt.length-1)) {
                    ix++;
                } else {
                    ix = 0;
                }
                tntId = arrayTnt[ix];

                payload = {
                    ...payload,
                    ix : ix,
                    tntId: tntId
                }




                if (tntId === 0) {
                    dispatch(receiveAutoclavesMonitor(payload));
                    return;
                }
                const {periodMin, periodMax} = getState().filter;
                let url = `/thot/autoclaves-monitor?tntId=${tId}`;
                console.log(url);
                const response = await axios.get(url)
                console.log("response getThotI4Monitor", response);
                let r = {
                    ix: ix,
                    tntId: tntId,
                    tDescricao: response.data? response.data[0].tDescricao : '',
                    eDescricao: response.data? response.data[0].eDescricao : '',
                    estabelecimentoTipoId: response.data? response.data[0].estabelecimentoTipoId : 0,
                    data: response.data
                }

                payload = r;
            }
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e, ix: ix, tntId: tntId };
        }
        finally {
            dispatch(receiveAutoclavesMonitor(payload));
        }
    }
}

